import * as React from "react";
import {IWindow} from "../index";
import {observable} from "mobx";
import {observer} from "mobx-react";

@observer
export default class App extends React.Component<any, any> {
    @observable pageClass: any;

    constructor(props: any) {
        super(props);

        const IWindow:IWindow = (window as IWindow);

        Promise.resolve(import('./pages/' + IWindow.pageComponent)).then((module) => {
		console.log(IWindow.pageComponent.split('/').slice(-1)[0]);
		console.log(module[IWindow.pageComponent.split('/').slice(-1)[0]]);
		
            this.pageClass = module[IWindow.pageComponent.split('/').slice(-1)[0]];
        });
    }

    render() {
        if (this.pageClass) {
		
            const pageComponent = React.createElement(this.pageClass);

            return (
                <div>
                    {pageComponent}
                </div>
            );
        }

        return (
            <div>
                {'Loading ...'}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/App.tsx